import { Chip, Paper, Typography } from "@mui/material";
import { Grid, Stack } from "@mui/system";
import { useSelector } from "react-redux";

const DataStoreRequestRunQueryInfo = () => {
  const { queryContentSingle } = useSelector(
    (state: any) => state.dataStoreReq
  );

  const { name, description, type, modules, id, database } =
    queryContentSingle ?? {};

  return (
    <>
      <Paper sx={{ padding: "16px", mb: 2 }}>
        <Grid container mt={0}>
          <Grid size={12}>
            <Stack flexDirection={"row"} alignItems={"center"}>
              <Typography fontSize={24}>
                {name ?? ""}
                {` (${id ?? ""})`}
              </Typography>
              {modules &&
                modules.map((item: any) => (
                  <Chip
                    label={item}
                    color="secondary"
                    sx={{ height: "30px", mr: "4px", ml: "10px" }}
                  />
                ))}
            </Stack>

            <Stack flexDirection={"row"} alignItems={"center"} my={0.5}>
              <Typography fontSize={14}>
                <strong style={{ fontWeight: "500" }}>ID: </strong> {id ?? ""}
              </Typography>
              <Typography fontSize={14} mx={2}>
                <strong style={{ fontWeight: "500" }}>Database: </strong>
                {database ?? ""}
              </Typography>
              <Typography fontSize={14}>
                <strong style={{ fontWeight: "500" }}>Type: </strong>
                {type ?? ""}
              </Typography>
            </Stack>

            <Stack flexDirection={"row"} alignItems={"flex-end"}>
              <Typography fontSize={14}>{description ?? ""}</Typography>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default DataStoreRequestRunQueryInfo;
